/**
 * 项目中的数据请求
*/
import axios from 'axios'
import JSONbig from 'json-bigint'
import * as CONSTANT from '@/utils/CONSTANT'

// 号主信息
export const requestMaster = axios.create({
  baseURL: CONSTANT.BASE_URL_BJD, // 基础路径
  // baseURL: '/haozhu',
  // headers: {
  //   app_key: 'newsroom-cms',
  //   app_secret: 'fiipqFJ6SAcrlIs5yypz' // 测试：bbbbbbaaaaaaaaaaaaa
  // },
  transformResponse: [function (data) {
    try {
      return JSONbig.parse(data)
    } catch (err) {
      return data
    }
  }]
})

// 号主页文章列表
export const request = axios.create({
  baseURL: CONSTANT.BASE_URL_WEN_ZHENG, // 基础路径
  // baseURL: '/haozhu',
  // headers: {
  //   app_key: 'newsroom-cms',
  //   app_secret: 'fiipqFJ6SAcrlIs5yypz' // 测试：bbbbbbaaaaaaaaaaaaa
  // },
  transformResponse: [function (data) {
    try {
      return JSONbig.parse(data)
    } catch (err) {
      return data
    }
  }]
})

// 北京号列表请求
export const requestBjh = axios.create({
  // baseURL: '/news',
  // baseURL: 'https://ie.bjd.com.cn/',
  // http://168.160.251.189:9200/
  baseURL: CONSTANT.BASE_URL_WEN_ZHENG,
  // headers: {
  //   app_key: 'newsroom-cms',
  //   app_secret: 'fiipqFJ6SAcrlIs5yypz'
  // },
  transformResponse: [function (data) {
    try {
      // console.log('转换成功')
      return JSONbig.parse(data)
    } catch (err) {
      // console.log('转换失败', err)
      return data
    }
  }]
})

// 北京号列表请求
export const requestBjhRank = axios.create({
  // baseURL: '/news',
  // baseURL: 'https://ie.bjd.com.cn/',
  // http://168.160.251.189:9200/
  baseURL: CONSTANT.BASE_URL_WEN_ZHENG,
  // headers: {
  //   app_key: 'newsroom-comment',
  //   app_secret: '1d859ca37264fe3b8f'
  // },
  headers: {
    'client-type': 'app'
  },
  transformResponse: [function (data) {
    try {
      // console.log('转换成功')
      return JSONbig.parse(data)
    } catch (err) {
      // console.log('转换失败', err)
      return data
    }
  }]
})

export const requestBjhField = axios.create({
  // baseURL: '/field',
  baseURL: CONSTANT.BASE_URL_BJD,
  // headers: {
  //   app_key: 'newsroom-cms',
  //   app_secret: 'fiipqFJ6SAcrlIs5yypz'
  // },
  transformResponse: [function (data) {
    try {
      // console.log('转换成功')
      return JSONbig.parse(data)
    } catch (err) {
      // console.log('转换失败', err)
      return data
    }
  }]
})
